<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid }"
  >
    <div
      class="flowMeterAlertContainer"
    >
      <v-icon
        size="30"
        color="red"
      >
        mdi-alert-outline
      </v-icon>
      <div
        v-if="!isEditing"
        class="flowMeterAlertMessage"
      >
        <span v-if="meter.alertType === TYPE_UPPER_ALERT">
          {{ $t(`devices.upperAlertPart1`) }}
        </span>
        <span
          v-if="meter.alertType === TYPE_UPPER_ALERT"
          class="font-weight-bold"
        >
          {{ $t(`devices.moreThanTimes`) }}
        </span>
        <span v-if="meter.alertType === TYPE_UPPER_ALERT">
          {{ $t(`devices.upperAlertPart2`) }}
        </span>
        <span v-if="meter.alertType === TYPE_LOWER_ALERT">
          {{ $t(`devices.lowerAlert`) }}
        </span>
      </div>
      <div
        v-else
        class="flowMeterEditSection"
      >
        <div class="flowMeterEditTitle">
          {{ $t('forms.labels.resetValueDateTitle') }}
        </div>
        <div class="flowMeterEditInputs">
          <VTextField
            v-model="meter.value"
            type="number"
            :rules="{ required: true}"
            :label="$t('forms.labels.resetValue')"
            clearable
          />
          <VDateTimePicker
            v-model="lastReadingDate"
            :label="$t('forms.labels.dateTime')"
          />
        </div>
      </div>
      <div class="flowMeterAlertActions">
        <v-btn
          v-if="!isEditing"
          color="#f2f2f2"
          elevation="0"
          @click="edit"
        >
          {{ $t('forms.labels.edit') }}
        </v-btn>
        <v-btn
          elevation="0"
          color="primary"
          :disabled="isEditing && !valid"
          @click="confirm"
        >
          {{ $t('confirm') }}
        </v-btn>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VDateTimePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDateTimePicker.vue';
import { ValidationObserver } from 'vee-validate';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
    name: 'FlowMetersAlert',
    components: { ValidationObserver, VDateTimePicker, VTextField },
    props: {
        meter: {
            type: Object,
            default: () => {},
        },
        isClosed: {
            type: Boolean,
            default: false,
        },
        close: {
            type: Function,
            default: () => null,
        },
        refreshReading: {
            type: Function,
            default: () => null,
        },
    },
    data() {
        return {
            isEditing: this.onlyForm,
            lastReadingDate: moment().toISOString(),
        };
    },
    computed: {
        ...mapGetters(['site']),
        TYPE_UPPER_ALERT() {
            return 'UPPER';
        },
        TYPE_LOWER_ALERT() {
            return 'LOWER';
        },
    },
    watch: {
        isClosed: {
            handler() {
                if (this.isClosed) this.isEditing = false;
            },
        },
    },
    methods: {
        edit() {
            this.isEditing = true;
        },
        async confirm() {
            const manualChanges = {
                value: this.meter.value,
                lastReadingDate: moment(this.lastReadingDate).toISOString(),
            };
            await this.refreshReading(manualChanges);
            this.close();
        },
    },
};
</script>
<style scoped lang="scss">
@import './FlowMetersAlertStyles.scss';
</style>
